import { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../../components/Footer';
import Header from '../../components/Header/Header';
import { HomeWrapper } from '../GamePage/GamePage.styled';
import { StyleTransactionsContainer, StyleTopBar, StyleTransactionTable, StylePagination } from './Transactions.styled';
import { PlayerContext } from '../../contexts/playerContext';

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

export const TransactionPage: React.FC = () => {
  const playerContext = useContext(PlayerContext);
  const today = new Date();

  const [startDate, setStartDate] = useState<string>(`${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate() - 1}`);
  const [endDate, setEndDate] = useState<string>(`${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`);
  const [items, setItems] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [loading, setLoading] = useState(false);

  const limit = 10; // Items per page

  useEffect(() => {
    const fetchItems = async () => {
      setLoading(true);
      const [startYear, startMonth, startDay] = startDate.split("-").map(Number); // Split and convert to numbers
      const [endYear, endMonth, endDay] = endDate.split("-").map(Number); // Split and convert to numbers
      const startLocalDate = new Date(startYear, startMonth - 1, startDay); // Create local date (month is 0-based)
      const endLocalDate = new Date(endYear, endMonth - 1, endDay); // Create local date (month is 0-based)
      startLocalDate.setHours(0, 0, 0, 0);
      endLocalDate.setHours(23, 59, 59, 999);
      try {
        const query = new URLSearchParams({
          start: startLocalDate.toISOString(),
          end: endLocalDate.toISOString()
        }).toString();
        const response = await fetch(`${API_ENDPOINT}/post/transactions/${page}/${limit}/${playerContext?.wallet.publicKey?.toString()}?${query}`);
        const data = await response.json();
        setItems(data.transactions);
        setTotalPages(data.totalPages);
        setTotalItems(data.totalItems);
      } catch (error) {
        console.error("Error fetching items:", error);
      } finally {
        setLoading(false);
      }
    };

    if (playerContext?.wallet.publicKey?.toString() == undefined) return;
    fetchItems();
  }, [page, startDate, endDate, playerContext?.wallet]);

  const handlePrevPage = () => setPage(prev => Math.max(prev - 1, 1));
  const handleNextPage = () => setPage(prev => Math.min(prev + 1, totalPages));

  const convertToLocalTime = (date: string) => {
    const localDate = new Date(date);
    return localDate.toLocaleString();
  }

  const shortenHash = (hash: string, startLength = 6, endLength = 4) => {
    if (!hash) return ""; // Handle cases where hash might be undefined or null
    return `${hash.slice(0, startLength)}...${hash.slice(-endLength)}`;
  }

  return (
    <HomeWrapper>
      <Header />
      <StyleTransactionsContainer>
        <StyleTopBar>
          <h2>Transaction History</h2>
          <div className='date'>
            <div>
              <span style={{ fontSize: '14px' }}>From:</span>
              <input
                type="date"
                defaultValue={`${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate() - 1}`}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </div>
            <div>
              <span style={{ marginLeft: '10px', fontSize: '14px' }}>To:</span>
              <input
                type="date"
                defaultValue={`${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </div>
          </div>
        </StyleTopBar>
        <p style={{ color: "#FFF", textAlign: 'end', fontSize: '14px' }}>{totalItems} results</p>
        <StyleTransactionTable>
          <thead>
            <tr>
              <th>No</th>
              <th>TXID</th>
              <th>Amount</th>
              <th>Type</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {
              items.map((item: any, index) => (
                <tr key={index}>
                  <td>{(page - 1) * 10 + index + 1}</td>
                  <td><Link to={`https://solscan.io/tx/${item.signature}`} target="_blank" className="player-link">{shortenHash(item.signature)}</Link></td>
                  <td>{item.balance / 1000} SOL</td>
                  <td>{item.status == 0 ? "Deposit" : "Withdraw"}</td>
                  <td>{convertToLocalTime(item.created_at)}</td>
                </tr>
              ))
            }
          </tbody>
        </StyleTransactionTable>
        <StylePagination>
          <button onClick={handlePrevPage} disabled={page === 1}>
            Previous
          </button>
          <span> Page {page} of {totalPages} </span>
          <button onClick={handleNextPage} disabled={page === totalPages}>
            Next
          </button>
        </StylePagination>
      </StyleTransactionsContainer>
      <Footer />
    </HomeWrapper>
  );
};